import BentoOrderingApp from 'bento-ordering/base/containers/App';
import CateringApp from 'catering/base/containers/App';
import { CATERING_BASE_PATH } from 'catering/base/constants/basePaths';
import {
  ONLINE_ORDERING_BASE_PATH,
  DINE_IN_BASE_PATH
} from 'bento-ordering/base/constants/basePaths';

class PathNotSupportedException extends Error {
  constructor(message = '', ...args) {
    super(message, ...args);
    this.name = 'PathNotSupportedException';
    this.message = `${message} is not a supported path`;
  }
}

const getApp = () => {
  // ssr check
  if (!window) {
    return null;
  }
  const pathname = window.location.pathname;
  if (pathname.startsWith(CATERING_BASE_PATH)) {
    return CateringApp;
  } else if (
    pathname.startsWith(ONLINE_ORDERING_BASE_PATH) ||
    pathname.startsWith(DINE_IN_BASE_PATH)
  ) {
    return BentoOrderingApp;
  } else {
    throw new PathNotSupportedException(pathname);
  }
};

export default getApp;
